// tslint:disable:jsx-no-lambda
import * as React from 'react';

import { Button, ComboBox, Modal, TextInput, VALIDATION_STATE } from '@abb/common-ux';
import { Option } from 'react-select';

interface IDownloadModalState {
  comments: string | null;
  commentsValidationStatus: VALIDATION_STATE;
  commentsErrorMessage: string;
}

interface IConfirmationModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  loadingText?: string | null;
  contactEmail?: string | null;
  requesterName?: string | null;
  onClose: () => void;
  onCommentsProvided: (comments: string) => void;
  onApprove: () => void;
  onReject: () => void;
}

export class ReqApprovalRejectionModel extends React.Component<IConfirmationModalProps, IDownloadModalState> {
  constructor(props: any) {
    super(props);
    this.state = {
      comments: '',
      commentsValidationStatus: 'none',
      commentsErrorMessage: ''
    };
  }

  onApprove = () => {
    this.props.onCommentsProvided(this.state.comments as string);
    this.props.onApprove();
  }

  onReject = () => {
    this.props.onCommentsProvided(this.state.comments as string);
    this.props.onReject();
  }

  onModelCommentsEntered = (event: React.ChangeEvent<any>) => {
    if (event.target.value.length > 5000) {
      this.setState({comments: event.target.value, commentsValidationStatus: 'invalid', commentsErrorMessage: 'Comments too long. Value cannot exceed 5000 characters.'});
    } else {
      this.setState({comments: event.target.value, commentsValidationStatus: 'valid', commentsErrorMessage: ''});
    }
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState(nextProps);
  }

  onClose = () => {
    this.setState({ comments: '', commentsValidationStatus: 'none', commentsErrorMessage: '' });
    this.props.onClose();
  }

  render() {
    const footerElem = (
      <div className='text-right'>
        <span style={{marginRight: '10px'}} >{this.props.isLoading ? this.props.loadingText : ''}</span>
        <Button buttonType='normal' buttonSize='default' id='cancelDownloadModal'  onClick={this.onClose}>Cancel</Button>
        <Button buttonType='primary' buttonSize='default' id='applyDownloadModal' onClick={this.onReject} disabled={this.props.isLoading || (this.state.commentsValidationStatus === 'invalid' ? true : false)}>Reject</Button>
        <Button buttonType='primary' buttonSize='default' id='applyDownloadModal' onClick={this.onApprove} disabled={this.props.isLoading || (this.state.commentsValidationStatus === 'invalid' ? true : false)}>Approve</Button>
      </div>
    );

    return (
      <Modal
        header={'Approve or Reject Request'}
        isOpen={this.props.isOpen}
        onClose={this.onClose}
        footer={footerElem}
        modalClassName='approvalRejectionModal'
        >
        <div className='row'>
          <div className='col-sm-12'>
            <div>
              <TextInput
                type='text'
                labelText='Comments (Internal Use Only)'
                name='contactName'
                value={this.state.comments as string}
                onChange={this.onModelCommentsEntered}
                inputSize='small'
                isRequired={false}
                validationState={this.state.commentsValidationStatus}
                errorMessage={this.state.commentsErrorMessage}
                placeholder='Enter Comments (optional)'
              />
            </div>
            <div>
              <span>
                <b>On approval an email will be sent to:</b> 
                <br/> {this.props.contactEmail} 
                <br/>
                <br/><b>On rejection the customer will not be notified that their request was rejected.</b>
                <br/>Please consider their email {this.props.contactEmail} in case you decide to follow up.
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
